export var VisibilityContent;
(function (VisibilityContent) {
    VisibilityContent[VisibilityContent["LESS_THAN_50M"] = 90] = "LESS_THAN_50M";
    VisibilityContent[VisibilityContent["BETWEEN_200M"] = 91] = "BETWEEN_200M";
    VisibilityContent[VisibilityContent["BETWEEN_500M"] = 92] = "BETWEEN_500M";
    VisibilityContent[VisibilityContent["BETWEEN_1KM"] = 93] = "BETWEEN_1KM";
    VisibilityContent[VisibilityContent["BETWEEN_2KM"] = 94] = "BETWEEN_2KM";
    VisibilityContent[VisibilityContent["BETWEEN_4KM"] = 95] = "BETWEEN_4KM";
    VisibilityContent[VisibilityContent["BETWEEN_10KM"] = 96] = "BETWEEN_10KM";
    VisibilityContent[VisibilityContent["BETWEEN_20KM"] = 97] = "BETWEEN_20KM";
    VisibilityContent[VisibilityContent["BETWEEN_50KM"] = 98] = "BETWEEN_50KM";
    VisibilityContent[VisibilityContent["MORE_THAN_50KM"] = 99] = "MORE_THAN_50KM";
})(VisibilityContent || (VisibilityContent = {}));
export const visibilityContentOptions = [
    { value: VisibilityContent.LESS_THAN_50M, text: '90 - less than 50m' },
    { value: VisibilityContent.BETWEEN_200M, text: '91 - 50m but less than 200m' },
    { value: VisibilityContent.BETWEEN_500M, text: '92 - 200m but less than 500m' },
    { value: VisibilityContent.BETWEEN_1KM, text: '93 - 500m but less than 1km' },
    { value: VisibilityContent.BETWEEN_2KM, text: '94 - 1km but less than 2km' },
    { value: VisibilityContent.BETWEEN_4KM, text: '95 - 2km but less than 4km' },
    { value: VisibilityContent.BETWEEN_10KM, text: '96 - 4km but less than 10km' },
    { value: VisibilityContent.BETWEEN_20KM, text: '97 - 10km but less than 20km' },
    { value: VisibilityContent.BETWEEN_50KM, text: '98 - 20km but less than 50km' },
    { value: VisibilityContent.MORE_THAN_50KM, text: '99 - 50km or more' },
];
//# sourceMappingURL=VisibilityContent.js.map